// extracted by css-extract-rspack-plugin
export default {"cls1":"SocialProofUniversityFooter-cls1_7tJ","cls2":"SocialProofUniversityFooter-cls2_BJE SocialProofUniversityFooter-cls1_7tJ"};